import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const multiEllipsis = (line: number) => css`
  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;
  -webkit-line-clamp: ${line};
  -webkit-box-orient: vertical;
`

export const ellipsis = css`
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
`

type BrProps = { show: 'desktop' | 'mobile' }

export const Br = styled.br<BrProps>`
  display: ${({ show }) => (show === 'desktop' ? 'block' : 'none')};

  ${({ theme: { device }, show }) => css`
    @media ${device.mobile} {
      display: ${show === 'mobile' ? 'block' : 'none'};
    }
  `}
`
